import axios from "axios";

import { toastErrorMessage } from "../../utils/toastMessage/toastMessage";
import { getCookies } from "../../utils";

// Axios Setting
// Common Headers

const accessToken = getCookies("accessToken");

if (accessToken)
  axios.defaults.headers.common["Authorization"] = `token ${accessToken}`;

axios.defaults.headers.common["Accept"] = "application/json";
// End

// Post Headers
axios.defaults.headers.post["Content-Type"] = "application/json";
// End

axios.interceptors.response.use(null, (error) => {
  const expectedErrors =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (error.response && error.response.status === 401) {
    // window.location.href = baseAdminURL + "/Auth/Logout"
  }

  if (!expectedErrors) {
    toastErrorMessage("مشکلی از سمت سرور رخ داده است.");
  }
  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
